
import {getTableColor, formatCellValue} from './utils';
import styled from 'styled-components';
import { useTheme } from 'styled-components';

export const StyledTable = styled.div`
  overflow-x: auto;
  height: 300px;
  overflow-y: auto;
  /* Using your theme object for the container */

  table {
    width: 100%;
    border-collapse: collapse;

    thead {
      position: sticky;
      top: 0;
      z-index: 1;
      /* Sticky headers need a background color or they become transparent */
      background: ${({ theme }) => theme.darkMode ? '#1a1a1a' : 'white'};
    }

    th {
      padding: 8px 8px;
      text-align: left;
      font-size: 12px;
      font-weight: 400;
      text-transform: uppercase;
      /* Dynamic border color */
      border-bottom: 1px solid ${({ theme }) => theme.darkMode ? 'rgb(51, 51, 51)' : '#e5e7eb'};
      color: ${({ theme }) => theme.darkMode ? '#9ca3af' : 'rgb(51, 51, 51)'};
    }

    td {
      padding: 4px;
      font-weight: 400;
      font-size: 14px;
      border-bottom: 1px solid ${({ theme }) => theme.darkMode ? 'rgb(51, 51, 51)' : '#e5e7eb'};
      color: ${({ theme }) => theme.darkMode ? '#f3f4f6' : '#1a1a1a'};
    }

    tr:hover {
      /* Subtle hover effect for both modes */
      background: ${({ theme }) => theme.darkMode ? 'rgb(51, 51, 51)' : '#f9fafb'};
    }
  }
`;


export const SimpleTableView = ({data, widget }:any) =>{
  const keys = Array.isArray(widget.dataKey) ? [widget.xKey, ...widget.dataKey] : [widget.xKey, widget.valueKey];

  // Helper to get column configuration
  const getColumnConfig = (key: string) => {
    return widget.columnConfig?.[key] || {};
  };

    return (
      <StyledTable style={{height: widget.height || '200px' }}>
        <table>
          <tbody>
            {data.map((row:any, idx:any) => {
              return (
              <tr key={idx}>
                {keys.map((key,index) => {
                  const colConfig = getColumnConfig(key);
                  return (
                    <td 
                      key={`${idx}-${key}`}
                      style={{
                        fontWeight: index === 0 ? 500 : 600,
                        color: getTableColor(key, row, widget.fields),
                        textAlign: index === 0 ? 'left' : 'right',
                        width: colConfig.width,
                        minWidth: colConfig.minWidth,
                        maxWidth: colConfig.maxWidth,
                      }}>
                      {(() => {
                        const val = row[key];
                        return formatCellValue(val, widget.isPricing === true);
                      })()}
                    </td>
                  );
                })}
              </tr>
            )
            })
          }
          </tbody>
        </table>
      </StyledTable>
    );
}


export const TableView = ({data, widget }:any) =>{
const keys = Array.isArray(widget.dataKey) ? [widget.xKey, ...widget.dataKey] : [widget.xKey, widget.valueKey];
  const theme = useTheme();
    return (
      <StyledTable style={{height: widget.height || '200px' }}>
        <table>
          {<thead>
            <tr key={'header'}>
              {keys.map((key,index) => (
                <th key={key} style={{
                  color: (theme.darkMode ? '#f9fafb' : '#1a1a1a') ,
                  borderRight:index < keys.length-1 ? (theme.darkMode ? '1px solid rgb(51, 51, 51)' : '1px solid #e5e7eb') :'none'
                }}>{key}</th>
              ))}
            </tr>
          </thead>}
          <tbody>
            {data.map((row:any, idx:any) => {
              return (
              <tr key={idx}>
                  { keys.map((key:any,kIdx:any) => (
                      <td 
                        key={`${idx}-${key}`}
                      style={{
                        fontWeight: kIdx === 0 ? 500 : 600,
                        color: getTableColor(key, row, widget.fields),
                        textAlign:kIdx === 0 ? 'left' : 'right',
                        minWidth: kIdx === 0 ? '80px' :'60px',
                      }} title={kIdx === 0 ? row[key] :""}>
                        {(() => {
                          // 1. Format the value first
                          const rawValue = row[key];
                          let formattedValue = typeof rawValue === 'number' && widget.isPricing === true
                            ? `$${rawValue.toLocaleString()}`
                            : rawValue?.toLocaleString() ?? "";

                          // 2. Check length and truncate if needed
                          return formattedValue.length > 16 
                            ? `${formattedValue.slice(0, 16)}...` 
                            : formattedValue;
                        })()}
                      </td>
                    ))}
              </tr>
            )
            })
          }
          </tbody>
        </table>
      </StyledTable>
    );
}